<template>
    <div class="cc-consents">
        <div class="cc-consents__header">
            <div class="cc-consents__title">{{ translations['Terms of service'] }}</div>
        </div>
        <div class="cc-consents__main">
            <div class="cc-form-input">
                <input id="consents.termsOfService" type="checkbox" name="consents.termsOfService" class="cc-input cc-input--checkbox" :checked="consents.termsOfService" @change="updateConsentTermsOfService">
                <label for="consents.termsOfService" class="cc-label cc-label--checkbox">{{ translations['I accept terms of service'] }} <a :href="config.consents.terms_of_use.link" target="_blank" class="cc-link">({{ translations['Read'] }})</a></label>
                <div class="cc-alert cc-alert--error" v-if="consents.errors.termsOfService">{{ consents.errors.termsOfService }}</div>
            </div>
            <div class="cc-form-input" v-if="config.customer_satisfaction_survey">
                <input id="consents.customerSatisfactionSurvey" type="checkbox" name="consents.customerSatisfactionSurvey" class="cc-input cc-input--checkbox" :checked="consents.customerSatisfactionSurvey" @change="updateConsentCustomerSatisfactionSurvey">
                <label for="consents.customerSatisfactionSurvey" class="cc-label cc-label--checkbox">{{ translations['I disagree with participating in customer satisfaction survey'] }}</label>
            </div>
            <div class="cc-form-input" v-if="config.independent_shop_survey">
                <input id="consents.independentShopRating" type="checkbox" name="consents.independentShopRating" class="cc-input cc-input--checkbox" :checked="consents.independentShopRating" @change="updateConsentIndependentShopRating">
                <label for="consents.independentShopRating" class="cc-label cc-label--checkbox">{{ translations['I agree with participating in independent shop survey'] }}</label>
            </div>
            <div class="cc-form-input">
                <dm-heureka-consent />
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import DmHeurekaConsent from "@/components/_common/modules/dm_heureka/DmHeurekaConsent";

    export default {
      components: {DmHeurekaConsent},
        computed: {
            ...mapState({
                translations: state => state.translations,
                consents: state => state.consents,
                config: state => state.config,
            }),
        },
        watch: {
            "consents.customerSatisfactionSurvey" (value) {
                this.$nextTick(() => {
                    $.uniform.update();
                });
            }
        },
        methods: {
            updateConsentTermsOfService: function (event) {
                this.$store.commit('SET_CONSENT_TERMS_OF_SERVICE', event.target.checked);
            },
            updateConsentCustomerSatisfactionSurvey: function (event) {
                this.$store.commit('SET_CONSENT_CUSTOMER_SATISFACTION_SURVEY', event.target.checked);
            },
            updateConsentIndependentShopRating: function (event) {
                this.$store.commit('SET_CONSENT_INDEPENDENT_SHOP_RATING', event.target.checked);
            },
        },
        name: 'Consents',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-consents {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-consents__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-consents__title {
            font-family: "Oswald", sans-serif;
            font-size: 25px;
            line-height: 1;
            display: inline-block;
            text-transform: uppercase;
        }

        .cc-consents__main {
            display: block;
            width: 100%;
            max-width: 100%;
            margin-top: 2.5rem;
        }
    }
</style>
<style>
  label[for="dm_heureka_consent"] {
    margin-bottom: 0;
    font-weight: normal;
    display: inline;
  }
</style>
